const AAA_PREFIX = 'base'

const USER = '/base/admin'

const SCENE_MNG = 'scene'

const COLLECT_REPORT = 'collect/report'

const POC_MNG = 'projectInfo'

const PROJECT_COLLECT_REPORT = 'collect/report/compat'

// 系统管理员、批任务
const ADMIN = `${AAA_PREFIX}/admin`

export { ADMIN, COLLECT_REPORT, USER, SCENE_MNG, POC_MNG, PROJECT_COLLECT_REPORT }
